<div class="neo-wait-host">
  <igx-dialog #waitDialog>
    <section id="dialog-card" class="neo-wait-card" role="status" aria-live="polite">
      <div class="neo-wait-spinner" aria-hidden="true"></div>
      <div class="neo-wait-copy">
        <div class="neo-wait-title" [innerHTML]="MENSAJE | translate"></div>
        @if (MENSAJE2) {
          <div class="neo-wait-subtitle" [innerHTML]="MENSAJE2 | translate"></div>
        }
        @if (MENSAJE3) {
          <div class="neo-wait-meta" [innerHTML]="MENSAJE3 | translate"></div>
        }
      </div>
    </section>
  </igx-dialog>
</div>
